import {
  PAYROLL_ADJUSTMENT_TYPES,
  RIDER_PAYROLL_PAYMENT_METHODS,
} from "@artisancode/api-types";
import { z } from "zod";

export const payrollAdjustmentSchema = z.object({
  type: z.enum(PAYROLL_ADJUSTMENT_TYPES),
  label: z.string().min(1, "Label wajib diisi"),
  amount: z.number().min(0, "Nominal minimal 0"),
});

export type PayrollAdjustmentFormValues = z.infer<
  typeof payrollAdjustmentSchema
>;

export const emptyPayrollAdjustment: PayrollAdjustmentFormValues = {
  type: "deduction",
  label: "",
  amount: 0,
};

export const riderPayrollSchema = z.object({
  riderId: z.string().min(1, "Rider wajib dipilih"),
  riderSaleIds: z
    .array(z.string())
    .min(1, "Pilih minimal 1 penjualan rider yang sudah selesai"),
  paymentMethod: z.enum(RIDER_PAYROLL_PAYMENT_METHODS),
  adjustments: z.array(payrollAdjustmentSchema),
  notes: z.string().optional(),
});

export type RiderPayrollFormValues = z.infer<typeof riderPayrollSchema>;

export const defaultRiderPayrollValues: RiderPayrollFormValues = {
  riderId: "",
  riderSaleIds: [],
  paymentMethod: "cash",
  adjustments: [],
  notes: "",
};
